import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'design-system';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { closeModal } from '@/store/slices/modal.slice';

const GlobalModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, content } = useAppSelector(state => state.modal);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) handleClose();
      }}
    >
      <DialogContent
        showCloseButton={false}
        className='w-[590px] max-w-[calc(100%-2rem)] gap-3 bg-gx-main-background p-6'
      >
        <DialogHeader>
          <DialogTitle>{content?.title}</DialogTitle>
        </DialogHeader>
        <div className='leading-none'>{content?.body}</div>
        <DialogFooter className='mx-0 mb-0 border-0 bg-transparent p-0 pr-3'>
          <Button
            className='w-[120px]'
            onClick={handleClose}
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalModal;
